var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { API_BASE_URL } from '../shared/service-proxies/service-proxies';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule, TabsModule, TooltipModule, TabsetConfig, TooltipConfig } from 'ngx-bootstrap';
import { DesignerMainRoutingModule } from './main-routing.module';
import { DesignWorkshopComponent } from './workshop/workshop.component';
import { LeaveWorkshopWarningModalComponent } from './workshop/shared/leave-workshop-warning-modal.component';
import { CreateOrEditConfigureVideoComponent } from './workshop/settings/configure-video/create-or-edit-configure-video.component';
import { ConfigureVideoComponent } from './workshop/settings/configure-video/configure-video.component';
import { CreateOrEditConfigurePermissionComponent } from './workshop/settings/configure-permission/create-or-edit-configure-permission.component';
import { ConfigurePermissionListComponent } from './workshop/settings/configure-permission/configure-permission-list.component';
import { ConfigureSettingsComponent } from './workshop/settings/configure-settings.component';
import { CreateOrEditVariableChooseMonitorModalComponent } from './workshop/data-configuration/configuration/variable/create-or-edit-modal/choose-monitor-modal/create-or-edit-variable-choose-monitor-modal.component';
import { CreateOrEditVariableModalComponent } from './workshop/data-configuration/configuration/variable/create-or-edit-modal/create-or-edit-variable-modal.component';
import { RenameVariableModalComponent } from './workshop/data-configuration/configuration/variable/batch-import-modal/rename-modal/rename-variable-modal.component';
import { BatchImportVariableModalComponent } from './workshop/data-configuration/configuration/variable/batch-import-modal/batch-import-variable-modal.component';
import { VariableGroupModalComponent } from './workshop/data-configuration/configuration/variable/variable-group-modal/variable-group-modal.component';
import { BatchEditVariableModalComponent } from './workshop/data-configuration/configuration/variable/batch-edit-modal/batch-edit-variable-modal.component';
import { HistoryDataComponent } from './workshop/data-configuration/configuration/history-data/history-data.component';
import { BatchEditAlarmModalComponent } from './workshop/data-configuration/configuration/alarm-registration/batch-edit-alarm-modal/batch-edit-alarm-modal.component';
import { RenameAlarmChooseModalComponent } from './workshop/data-configuration/configuration/alarm-registration/batch-import-modal/rename-choose-modal/rename-alarm-choose-modal';
import { BatchImportAlarmModalComponent } from './workshop/data-configuration/configuration/alarm-registration/batch-import-modal/batch-import-alarm-modal.component';
import { CreateOrEditAlarmModalComponent } from './workshop/data-configuration/configuration/alarm-registration/create-or-edit-alarm-modal/create-or-edit-alarm-modal.component';
import { AlarmGroupModalComponent } from './workshop/data-configuration/configuration/alarm-registration/alarm-group-modal/alarm-group-modal.component';
import { AlarmRegistrationComponent } from './workshop/data-configuration/configuration/alarm-registration/alarm-registration.component';
import { DataConfigurationComponent } from './workshop/data-configuration/configuration/data-configuration.component';
import { CreateOrEditEventModalComponent } from './workshop/data-configuration/configuration/event/create-or-edit-modal/create-or-edit-event-modal.component';
import { BatchEditEventModalComponent } from './workshop/data-configuration/configuration/event/batch-edit-modal/batch-edit-event-modal.component';
import { EventGroupModalComponent } from './workshop/data-configuration/configuration/event/event-group-modal/event-group-modal.component';
import { ConfigureEventComponent } from './workshop/data-configuration/configuration/event/configure-event.component';
import { DeadBandValueCheckDirective } from './workshop/data-configuration/configuration/shared/dead-band-value-check.directive';
import { DelayTimeCheckDirective } from './workshop/data-configuration/configuration/shared/delay-time-check.directive';
import { DevianceValueCheckDirective } from './workshop/data-configuration/configuration/shared/deviance-value-check.directive';
import { MaxValueCheckDirective } from './workshop/data-configuration/configuration/variable/create-or-edit-modal/max-value-check.directive';
import { MinValueCheckDirective } from './workshop/data-configuration/configuration/variable/create-or-edit-modal/min-value-check.directive';
import { ImportBoxDataModalComponent } from './workshop/shared/import-box-data-modal.component';
import { RenameVariableOrAlarmModalComponent } from './workshop/data-source-configuration/rename-modal/rename-variable-or-alarm-modal.component';
import { RawHistoryDataComponent } from './workshop/data-source-configuration/raw-history-data/raw-history-data.component';
import { RawVariableComponent } from './workshop/data-source-configuration/raw-variable/raw-variable.component';
import { RawAlarmRegistrationComponent } from './workshop/data-source-configuration/raw-alarm-registration/raw-alarm-registration.component';
import { RawEdgeComputingComponent } from './workshop/data-source-configuration/raw-edge-computing/raw-edge-computing.component';
import { CreateOrEditDataSourceModalComponent } from './workshop/data-source-configuration/create-or-edit-data-source-modal/create-or-edit-data-source-modal.component';
import { DataSourceConfigurationComponent } from './workshop/data-source-configuration/data-source-configuration.component';
import { PaletteComponent } from './workshop/designer/palette/palette.component';
import { RenameGraphSettingModalComponent } from './workshop/element-setting/shared/graph/rename-graph-setting.component';
import { GraphImportControlSettingComponent } from './workshop/element-setting/shared/control/graph-import-control-setting.component';
import { CreateOrEditGraphComponent } from './workshop/element-setting/shared/graph/create-or-edit-graph.component';
import { GalleryUserComponent } from './workshop/element-setting/shared/graph/user/gallery-user.component';
import { GalleryCurrentComponent } from './workshop/gallery/current/gallery-current.component';
import { GallerySysComponent } from './workshop/element-setting/shared/graph/system/gallery-sys.component';
import { GalleryGlobalModalComponent } from './workshop/gallery/gallery-global-modal.component';
import { ToolbarComponent } from './workshop/designer/toolbar/toolbar.component';
import { ZoomSettingsComponent } from './workshop/designer/toolbar/zoom/zoom-settings.component';
import { CopyConfigureViewModalComponent } from './workshop/designer/view/copy-view-modal/copy-view-modal.component';
import { ViewSettingsModalComponent } from './workshop/designer/view/view-setting/view-settings-modal.component';
import { ConfigureViewListComponent } from './workshop/designer/view/view-list.component';
import { GeneralPropertyComponent } from './workshop/element-setting/bar-graph/general/general-property.component';
import { CalibrationMarkComponent } from './workshop/element-setting/shared/calibration-mark/calibration-mark.component';
import { BitConditionComponent } from './workshop/element-setting/shared/condition/bit/bit-condition.component';
import { WordConditionComponent } from './workshop/element-setting/shared/condition/word/word-condition.component';
import { ConditionSettingModalComponent } from './workshop/element-setting/shared/condition/condition-setting-modal.component';
import { ConfigurePermissionComponent } from './workshop/settings/configure-permission/configure-permission.component';
import { ControlPermissionSettingComponent } from './workshop/element-setting/shared/control/control-permission-setting.component';
import { DisplaySettingComponent } from './workshop/element-setting/shared/display/display-setting.component';
import { BarGraphSettingModalComponent } from './workshop/element-setting/bar-graph/bar-graph-setting-modal.component';
import { DateTimeSettingModalComponent } from './workshop/element-setting/date-time/date-time-setting-modal.component';
import { EllipseSettingModalComponent } from './workshop/element-setting/ellipse/ellipse-setting-modal.component';
import { HistoryCurveCalibrationMarkComponent } from './workshop/element-setting/history-curve/calibration-mark/history-curve-calibration-mark.component';
import { HistoryCurveChannelSettingComponent } from './workshop/element-setting/history-curve/channel/history-curve-channel-setting.component';
import { HistoryCurveGeneralSettingComponent } from './workshop/element-setting/history-curve/general/history-curve-general-setting.component';
import { HistoryCurveSettingComponent } from './workshop/element-setting/history-curve/history-curve-setting.component';
import { ImageSettingModalComponent } from './workshop/element-setting/image/image-setting-modal.component';
import { MeterSettingModalComponent } from './workshop/element-setting/meter/meter-setting-modal.component';
import { NumericalDisplaySettingModalComponent } from './workshop/element-setting/numerical-display/numerical-display-setting-modal.component';
import { ConditionalControlComponent } from './workshop/element-setting/shared/display/conditional-control.component';
import { PipeSettingModalComponent } from './workshop/element-setting/pipe/pipe-setting-modal.component';
import { RectangleSettingModalComponent } from './workshop/element-setting/rectangle/rectangle-setting-modal.component';
import { RingGraphGeneralSettingComponent } from './workshop/element-setting/ring-graph/general/ring-graph-general-setting.component';
import { SectorSettingModalComponent } from './workshop/element-setting/sector/sector-setting-modal.component';
import { SwitchIndicatorLightBasicInfoComponent } from './workshop/element-setting/switch-indicator-light/switch-indicator-light-basic-info.component';
import { SwitchIndicatorLightSettingModalComponent } from './workshop/element-setting/switch-indicator-light/switch-indicator-light-setting-modal.component';
import { TextSettingModalComponent } from './workshop/element-setting/text/text-setting-modal.component';
import { HyperlinkModalComponent } from './workshop/element-setting/hyperlink/hyperlink-modal.component';
import { ToggleViewSettingModalComponent } from './workshop/element-setting/toggle-view/toggle-view-setting-modal.component';
import { StraightLineSettingComponent } from './workshop/element-setting/straight-line/straight-line-setting.component';
import { PolyLineSettingComponent } from './workshop/element-setting/poly-line/poly-line-setting.component';
import { PolygonSettingComponent } from './workshop/element-setting/polygon/polygon-setting.component';
import { CreateVideoComponent } from './workshop/element-setting/video/create-video.component';
import { VideoSettingComponent } from './workshop/element-setting/video/video-setting.component';
import { TableSettingComponent } from './workshop/element-setting/table/table-setting.component';
import { WeatherModalComponent } from './workshop/element-setting/weather/weather-modal.component';
import { ConfigureViewTabComponent } from './workshop/designer/view/view-tab.component';
import { ViewBackgroundSettingsComponent } from './workshop/designer/view/background/view-background-settings.component';
import { ConfigureViewComponent } from './workshop/designer/view/configure-view/configure-view.component';
import { ViewGeneralSettingComponent } from './workshop/designer/view/view-setting/view-general-setting.component';
import { ViewPopSettingComponent } from './workshop/designer/view/view-setting/view-pop-setting.component';
import { PolygonGeneralSettingComponent } from './workshop/element-setting/polygon/general/polygon-general-setting.component';
import { VisibilitySettingComponent } from './workshop/element-setting/shared/display/visibility-setting.component';
import { DynamicConductComponent } from './workshop/element-setting/shared/dynamic-conduct/dynamic-conduct.component';
import { ExtendPropertyComponent } from './workshop/element-setting/shared/extend-property/extend-property.component';
import { GallerySettingModalComponent } from './workshop/element-setting/shared/graph/gallery-setting-modal.component';
import { GraphStatesComponent } from './workshop/gallery/graph-states.component';
import { GraphSettingComponent } from './workshop/element-setting/shared/graph/graph-setting.component';
import { StateConditionPipe } from './workshop/element-setting/switch-indicator-light/state/state-condition-pipe.component';
import { StateIdPipe } from './workshop/element-setting/switch-indicator-light/state/state-id-pipe.component';
import { StateComponent } from './workshop/element-setting/switch-indicator-light/state/state.component';
import { TableGeneralSettingComponent } from './workshop/element-setting/table/general/table-general-setting.component';
import { GraphListComponent } from './workshop/gallery/graph-list.component';
import { GraphStateListComponent } from './workshop/gallery/graph-state-list.component';
import { FontSettingComponent } from './workshop/shared/font/font-setting.component';
import { FontStyleComponent } from './workshop/shared/font/font-style.component';
import { RenameTipsComponent } from './workshop/shared/rename/rename-tips.component';
import { RenameComponent } from './workshop/shared/rename/rename.component';
import { DesignerComponent } from './workshop/designer/designer.component';
import { VariableComponent } from './workshop/data-configuration/configuration/variable/variable.component';
import { BatchImportHistoryDataModalComponent } from './workshop/data-configuration/configuration/history-data/batch-imort-modal/batch-import-history-data-modal.component';
import { ChooseAlarmModalComponent } from './workshop/data-configuration/configuration/alarm-registration/create-or-edit-alarm-modal/choose-alarm-modal/choose-alarm-modal.component';
import { EnableSettingComponent } from './workshop/element-setting/shared/display/enable-setting.component';
import { ControlSettingComponent } from './workshop/element-setting/shared/control/control-setting.component';
import { CharacterSettingModalComponent } from './workshop/element-setting/character-display/character-setting-modal.component';
import { RingGraphSettingComponent } from './workshop/element-setting/ring-graph/ring-graph-setting.component';
import { MultiSelectModule, PaginatorModule, FileUploadModule as PrimeNgFileUploadModule, CheckboxModule, RadioButtonModule, GalleriaModule, MessagesModule, MessageModule, ButtonModule } from 'primeng/primeng';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { NgSelectModule } from '@ng-select/ng-select';
import { ValidationMessagesComponent } from '../shared/validation-messages.component';
import { BusyIfDirective } from '../shared/busy-if.directive';
import { TableModule, EditableRow } from 'primeng/table';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ButtonBusyDirective } from '../shared/button-busy.directive';
import { EllipsisPipe } from '../shared/ellipsis.pipe';
import { ChooseMonitorComponent } from './workshop/element-setting/shared/monitor/choose-monitors.component';
import { VariableSelectorComponent } from './workshop/element-setting/shared/variable/variable-selector.component';
import { FBoxAccountWarningComponent } from '../shared/fbox/fbox-account-warning';
import { FileUploadModule } from 'ng2-file-upload';
import { CustomFuncValidatorDirective } from '../shared/validation/custom-func-validator.directive';
import { EmailValidatorDirective } from '../shared/validation/email-validator.directive';
import { EqualValidator } from '../shared/validation/equal-validator.directive';
import { MaxLengthValidatorDirective } from '../shared/validation/max-length-validator.directive';
import { MinValueValidator } from '../shared/validation/min-value-validator.directive';
import { NotEmptyValidatorDirective } from '../shared/validation/not-empty-validator.directive';
import { NotNegativeIntegerValidatorDirective } from '../shared/validation/not-negative-integer-validator.directive';
import { PasswordComplexityValidator } from '../shared/validation/password-complexity-validator.directive';
import { PhoneNumberValidatorDirective } from '../shared/validation/phone-number-validator.directive';
import { UrlValidatorDirective } from '../shared/validation/url-validator.directive';
import { ColorPickerComponent } from './workshop/element-setting/color-picker/color-picker.component';
import { FontColorPickerComponent } from './workshop/element-setting/color-picker/font-color-picker/font-color-picker.component';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { DataSourceComboComponent } from './workshop/element-setting/shared/data-source/data-source-combo.component';
import { SafePipe } from '../shared/safe.pipe';
import { ImageUploaderComponent } from '../shared/image/image-uploader.component';
import { LeaveEditPageWarningComponent } from '../shared/unsave-warning/leave-edit-page-warning.component';
import { ToastModule } from 'primeng/toast';
import { GuiModule, LOGGER_SERVICE_TOKEN } from '@flexem/fc-gui';
import { ColorPickerModule } from 'ngx-color-picker';
import { AbpModule } from 'abp-ng2-module/src/abp.module';
import { AppSessionService } from '../shared/common/session/app-session.service';
import { ServiceProxyModule } from '../shared/service-proxies/service-proxy.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from '../shared/http-error-interceptor';
import { AbpHttpInterceptor } from 'abp-ng2-module/src/abpHttpInterceptor';
import { AppUiCustomizationService } from '../shared/common/ui/app-ui-customization.service';
import { DesignerSettingsServiceImpl } from './workshop/designer/settings/designer-settings.service.impl';
import { DESIGNER_SETTINGS_SERVICE } from './workshop/designer/settings/designer-settings.service';
import { LineGeneralSettingComponent } from './workshop/element-setting/line/line-general-setting.component';
import { DESIGNER_SETTINGS } from './workshop/core/settings/designer/designer-settings';
import { CONFIGURE_SETTINGS_STORE } from './workshop/core/settings/configure-settings-store';
import { DEFAULT_GRAPH_SETTINGS } from './workshop/core/settings/graph/default-graph-settings';
import { DefaultConfigureProjectInfo } from './workshop/core/project/impl/default-configure-project-info';
import { CONFIGURE_PROJECT_INFO } from './workshop/core/project/configure-project-info';
import { RemoteConfigureSettingsStore } from './workshop/core/settings/impl/remote-configure-settings-store';
import { RemoteVariableService } from './workshop/core/variable/impl/remote-variable.service';
import { VARIABLE_SERVICE } from './workshop/core/variable/variable.service';
import { BitConditionTypeOptionService } from './workshop/element-setting/shared/condition/bit/bit-condition-type-option.service';
import { DisplayTypeOptionService } from './workshop/element-setting/shared/display/display-type-option.service';
import { EnableTypeOptionService } from './workshop/element-setting/shared/display/enable-type-option.service';
import { VariableValueTypeOptionService } from './workshop/element-setting/shared/condition/comm/variable-value-type-option.service';
import { RelationTypeOptionService } from './workshop/element-setting/shared/condition/comm/relation-type-option.service';
import { RelationalOperatorOptionService } from './workshop/element-setting/shared/condition/comm/relational-operator-option.service';
import { LogicTypeOptionService } from './workshop/element-setting/shared/condition/comm/logic-type-option.service';
import { ArrowStyleTypeService } from './workshop/element-setting/line/general/arrow-style-type.service';
import { LineStyleTypeService } from './workshop/element-setting/line/general/line-style-type.service';
import { ViewTypeNameTranslateService } from './workshop/shared/view-type-name-translate-service';
import { RotationDirectionService } from './workshop/diagram/utils/dynamic/rotation-direction.service';
import { GraphTransformService } from './workshop/element-setting/shared/graph/graph-transform.service';
import { DynamicValidateService } from './workshop/diagram/utils/dynamic/dynamic-validate.service';
import { GraphService } from '../shared/gallery/graph.service';
import { PaletteService } from './workshop/designer/palette/palette.service';
import { ConditionTypeOptionService } from './workshop/element-setting/shared/condition/condition-type-option.service';
import { ConfigureSettingsLoadingHandler } from './workshop/core/settings/impl/configure-settings-loading-handler';
import { CONFIGURE_PROJECT_LOADING_HANDLERS } from './workshop/core/hook/configure-project-loading-handler';
import { DiagramModule } from './workshop/diagram/diagram.module';
import { FBoxModule } from '../shared/fbox/fbox/fbox.module';
import { ConfigureCommonModule } from '../shared/common/configure-common.module';
import { SyntaxHighlighterComponent } from '../shared/utils/syntax-high-lighter/syntax-highlighter-component';
import { FullScreenComponent } from '../shared/utils/full-screen/full-screen.component';
import { GuiLoggerService } from '../shared/logger/gui-logger.service';
import { ConfigureSimulationComponent } from './workshop/simulation/configure-simulation.component';
import { AppLocalizationService } from '../shared/common/localization/app-localization.service';
import { SVGService } from './workshop/shared/svg/svg.service';
import { DATA_SOURCE_SERVICE } from './workshop/core/data-source/data-source.service';
import { RemoteDataSourceService } from './workshop/core/data-source/impl/remote-data-source.service';
import { DesignerMainComponent } from './main.component';
import { AppConsts } from '../shared/AppConsts';
import { Logger } from '../shared/logger/logger';
import { ProvideParentFormDirective } from '../shared/utils/provide-parent-form.directive';
// @dynamic
export function getRemoteServiceBaseUrl() {
    // 获取后端服务器地址 可在fcloud中写入缓存
    AppConsts.appBaseUrlFormat = localStorage.getItem('appBaseUrl');
    AppConsts.remoteServiceBaseUrl = localStorage.getItem('remoteServiceBaseUrl');
    AppConsts.appBaseUrl = localStorage.getItem('appBaseUrl');
    return AppConsts.remoteServiceBaseUrl || localStorage.getItem('remoteServiceBaseUrl');
}
export function designerSettingsFactory(configureSettingsStore) {
    return configureSettingsStore.designerSettings;
}
export var designerSettingsProvider = {
    provide: DESIGNER_SETTINGS,
    useFactory: designerSettingsFactory,
    deps: [CONFIGURE_SETTINGS_STORE]
};
export function defaultGraphSettingsFactory(configureSettingsStore) {
    return configureSettingsStore.defaultGraphSettings;
}
export var defaultGraphSettingsProvider = {
    provide: DEFAULT_GRAPH_SETTINGS,
    useFactory: defaultGraphSettingsFactory,
    deps: [CONFIGURE_SETTINGS_STORE]
};
var DesignerMainModule = /** @class */ (function () {
    // @dynamic
    function DesignerMainModule() {
    }
    DesignerMainModule = __decorate([
        NgModule({
            imports: [
                HttpClientModule,
                CommonModule,
                FormsModule,
                AbpModule,
                TooltipModule.forRoot(),
                TabsModule.forRoot(),
                ModalModule.forRoot(),
                DiagramModule,
                FBoxModule.forRoot(),
                ConfigureCommonModule,
                DesignerMainRoutingModule,
                GuiModule,
                ReactiveFormsModule,
                MultiSelectModule,
                NgZorroAntdModule,
                NgSelectModule,
                TableModule,
                PaginatorModule,
                PrimeNgFileUploadModule,
                UiSwitchModule,
                CheckboxModule,
                RadioButtonModule,
                GalleriaModule,
                MessagesModule,
                MessageModule,
                ButtonModule,
                FileUploadModule,
                MultiselectDropdownModule,
                ToastModule,
                ColorPickerModule,
                ServiceProxyModule,
            ],
            declarations: [
                CustomFuncValidatorDirective,
                EmailValidatorDirective,
                EqualValidator,
                MaxLengthValidatorDirective,
                MinValueValidator,
                NotEmptyValidatorDirective,
                NotNegativeIntegerValidatorDirective,
                PasswordComplexityValidator,
                PhoneNumberValidatorDirective,
                UrlValidatorDirective,
                FullScreenComponent,
                ChooseMonitorComponent,
                VariableSelectorComponent,
                EllipsisPipe,
                ButtonBusyDirective,
                ValidationMessagesComponent,
                DesignWorkshopComponent,
                LeaveWorkshopWarningModalComponent,
                CreateOrEditConfigureVideoComponent,
                ConfigureVideoComponent,
                CreateOrEditConfigurePermissionComponent,
                ConfigurePermissionListComponent,
                ConfigureSettingsComponent,
                CreateOrEditVariableChooseMonitorModalComponent,
                CreateOrEditVariableModalComponent,
                RenameVariableModalComponent,
                BatchImportVariableModalComponent,
                VariableGroupModalComponent,
                BatchEditVariableModalComponent,
                HistoryDataComponent,
                BatchEditAlarmModalComponent,
                RenameAlarmChooseModalComponent,
                BatchImportAlarmModalComponent,
                CreateOrEditAlarmModalComponent,
                AlarmGroupModalComponent,
                AlarmRegistrationComponent,
                DataConfigurationComponent,
                CreateOrEditEventModalComponent,
                BatchEditEventModalComponent,
                EventGroupModalComponent,
                ConfigureEventComponent,
                DeadBandValueCheckDirective,
                DelayTimeCheckDirective,
                DevianceValueCheckDirective,
                MaxValueCheckDirective,
                MinValueCheckDirective,
                ImportBoxDataModalComponent,
                RenameVariableOrAlarmModalComponent,
                RawHistoryDataComponent,
                RawVariableComponent,
                RawAlarmRegistrationComponent,
                RawEdgeComputingComponent,
                CreateOrEditDataSourceModalComponent,
                DataSourceConfigurationComponent,
                PaletteComponent,
                RenameGraphSettingModalComponent,
                GraphImportControlSettingComponent,
                CreateOrEditGraphComponent,
                GalleryUserComponent,
                GalleryCurrentComponent,
                GallerySysComponent,
                GalleryGlobalModalComponent,
                ToolbarComponent,
                ZoomSettingsComponent,
                CopyConfigureViewModalComponent,
                ViewSettingsModalComponent,
                ConfigureViewListComponent,
                GeneralPropertyComponent,
                CalibrationMarkComponent,
                BitConditionComponent,
                WordConditionComponent,
                ConditionSettingModalComponent,
                ConfigurePermissionComponent,
                ControlPermissionSettingComponent,
                DisplaySettingComponent,
                BarGraphSettingModalComponent,
                DateTimeSettingModalComponent,
                EllipseSettingModalComponent,
                HistoryCurveCalibrationMarkComponent,
                HistoryCurveChannelSettingComponent,
                HistoryCurveGeneralSettingComponent,
                HistoryCurveSettingComponent,
                ImageSettingModalComponent,
                MeterSettingModalComponent,
                NumericalDisplaySettingModalComponent,
                ConditionalControlComponent,
                PipeSettingModalComponent,
                RectangleSettingModalComponent,
                RingGraphGeneralSettingComponent,
                SectorSettingModalComponent,
                SwitchIndicatorLightBasicInfoComponent,
                SwitchIndicatorLightSettingModalComponent,
                TextSettingModalComponent,
                HyperlinkModalComponent,
                ToggleViewSettingModalComponent,
                StraightLineSettingComponent,
                PolyLineSettingComponent,
                PolygonSettingComponent,
                CreateVideoComponent,
                VideoSettingComponent,
                TableSettingComponent,
                WeatherModalComponent,
                ConfigureViewTabComponent,
                ViewBackgroundSettingsComponent,
                ConfigureViewComponent,
                ViewGeneralSettingComponent,
                ViewPopSettingComponent,
                PolygonGeneralSettingComponent,
                VisibilitySettingComponent,
                DynamicConductComponent,
                DynamicConductComponent,
                ExtendPropertyComponent,
                GallerySettingModalComponent,
                GraphStatesComponent,
                GraphSettingComponent,
                LineGeneralSettingComponent,
                StateConditionPipe,
                StateIdPipe,
                StateComponent,
                TableGeneralSettingComponent,
                GraphStateListComponent,
                FontSettingComponent,
                GraphListComponent,
                FontStyleComponent,
                RenameTipsComponent,
                RenameComponent,
                DesignerComponent,
                VariableComponent,
                BatchImportHistoryDataModalComponent,
                ChooseAlarmModalComponent,
                EnableSettingComponent,
                ControlSettingComponent,
                CharacterSettingModalComponent,
                RingGraphSettingComponent,
                BusyIfDirective,
                SyntaxHighlighterComponent,
                FBoxAccountWarningComponent,
                ColorPickerComponent,
                FontColorPickerComponent,
                DataSourceComboComponent,
                SafePipe,
                ImageUploaderComponent,
                LeaveEditPageWarningComponent,
                ConfigureSimulationComponent,
                DesignerMainComponent,
                ProvideParentFormDirective
            ],
            providers: [
                { provide: API_BASE_URL, useFactory: getRemoteServiceBaseUrl },
                AppLocalizationService,
                AppUiCustomizationService,
                TabsetConfig,
                TooltipConfig,
                GraphService,
                EditableRow,
                SVGService,
                BitConditionTypeOptionService,
                DisplayTypeOptionService,
                EnableTypeOptionService,
                VariableValueTypeOptionService,
                RelationTypeOptionService,
                RelationalOperatorOptionService,
                LogicTypeOptionService,
                GraphTransformService,
                RotationDirectionService,
                DynamicValidateService,
                ViewTypeNameTranslateService,
                LineStyleTypeService,
                Logger,
                AppSessionService,
                ArrowStyleTypeService,
                designerSettingsProvider,
                defaultGraphSettingsProvider,
                DefaultConfigureProjectInfo,
                { provide: CONFIGURE_SETTINGS_STORE, useClass: RemoteConfigureSettingsStore },
                { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
                { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
                { provide: DESIGNER_SETTINGS_SERVICE, useClass: DesignerSettingsServiceImpl },
                { provide: CONFIGURE_PROJECT_INFO, useExisting: DefaultConfigureProjectInfo },
                { provide: VARIABLE_SERVICE, useClass: RemoteVariableService },
                ConditionTypeOptionService,
                { provide: CONFIGURE_PROJECT_LOADING_HANDLERS, useClass: ConfigureSettingsLoadingHandler, multi: true },
                GuiLoggerService,
                { provide: DATA_SOURCE_SERVICE, useClass: RemoteDataSourceService },
                { provide: LOGGER_SERVICE_TOKEN, useClass: GuiLoggerService },
                PaletteService
            ],
            entryComponents: [
                RenameGraphSettingModalComponent,
                CreateOrEditGraphComponent,
                GraphImportControlSettingComponent,
                GallerySettingModalComponent,
                ViewSettingsModalComponent,
                HistoryCurveSettingComponent,
                ConditionSettingModalComponent,
                RingGraphSettingComponent,
                CopyConfigureViewModalComponent,
                StraightLineSettingComponent,
                PolyLineSettingComponent,
                PolygonSettingComponent,
                ConfigurePermissionComponent,
                CreateOrEditConfigurePermissionComponent,
                VideoSettingComponent,
                CreateVideoComponent,
                CreateOrEditConfigureVideoComponent,
                TableSettingComponent,
                ChooseMonitorComponent,
                CreateOrEditDataSourceModalComponent,
                VariableGroupModalComponent,
                CreateOrEditVariableModalComponent,
                AlarmGroupModalComponent,
                CreateOrEditAlarmModalComponent,
                BatchImportVariableModalComponent,
                ConfigureSimulationComponent,
                RenameVariableOrAlarmModalComponent,
                CreateOrEditVariableChooseMonitorModalComponent,
                RenameVariableModalComponent,
                BatchEditVariableModalComponent,
                EventGroupModalComponent,
                BatchEditEventModalComponent,
                CreateOrEditEventModalComponent,
                ChooseAlarmModalComponent,
                BatchEditAlarmModalComponent
            ],
            exports: [
                EqualValidator,
                PasswordComplexityValidator,
                MinValueValidator,
                ButtonBusyDirective,
                BusyIfDirective,
                ValidationMessagesComponent,
                NotNegativeIntegerValidatorDirective,
                FullScreenComponent,
                CustomFuncValidatorDirective,
                MaxLengthValidatorDirective,
                NotEmptyValidatorDirective,
                SyntaxHighlighterComponent,
                SafePipe,
                PhoneNumberValidatorDirective,
                EmailValidatorDirective,
                LeaveEditPageWarningComponent,
                EllipsisPipe,
                ImageUploaderComponent,
                UrlValidatorDirective,
                ConfigureViewTabComponent,
                DataConfigurationComponent,
                DataSourceConfigurationComponent,
                DesignerComponent,
                ConfigureSettingsComponent,
                FBoxAccountWarningComponent,
                LeaveWorkshopWarningModalComponent,
                DesignerMainComponent,
                ProvideParentFormDirective,
                ConfigureSimulationComponent
            ]
        })
        // @dynamic
    ], DesignerMainModule);
    return DesignerMainModule;
}());
export { DesignerMainModule };
